
import { ADD_NEW_BUSINESS_ITEM, DELETE_BUSINESS_ITEM, GET_ALL_BUSINESS, GET_ALL_BUSINESS_FAILED, GET_ALL_BUSINESS_SUCCESS, SINGLE_BUSINESS_ITEM, UPDATE_BUSINESS_ITEM } from '../../constants/businessConstant';

const initialState = {
    businessData: {
        data: [],
        pagination: {
            page: 1
        }
    },
    singleBusiness:null,
    isLoading: false,
    error: null
};

export default function businessReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ALL_BUSINESS:
            return {
                ...state,
                isLoading: true,
                error: null
            };

        case GET_ALL_BUSINESS_SUCCESS:
            const isFirstPage = action.payload.page === 1;
            return {
                ...state,
                isLoading: false,
                businessData: {
                    data: isFirstPage
                        ? action.payload.data
                        : [...state.businessData.data, ...action.payload.data],
                    pagination: action.payload.pagination
                }
            };
        case ADD_NEW_BUSINESS_ITEM:
            return {
                ...state,
                isLoading: false,

                businessData: {
                    ...state.businessData,
                    data: [
                        ...(state.businessData?.data || []),
                        ...(action.payload?.data?.data ? [action.payload.data.data] : [])
                    ]
                }
            };
        case DELETE_BUSINESS_ITEM:
            const itemId = action.payload.id
            return {
                ...state,
                isLoading: false,
                businessData: {
                    ...state.businessData,
                    data: state.businessData.data.filter(item => item.id !== itemId)
                }
            };
        case UPDATE_BUSINESS_ITEM:
            return {
                ...state,
                isLoading: false,
                singleBusiness: action.payload.data.data
            };
        case SINGLE_BUSINESS_ITEM:
            return {
                ...state,
                isLoading: false,
                singleBusiness: action.payload
            };

        case GET_ALL_BUSINESS_FAILED:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };

        default:
            return state;
    }
}